module.exports={render:function (){with(this) {
  return _h('table', {
    staticClass: "calendar",
    attrs: {
      "id": id
    }
  }, [_h('thead', [_h('tr', [_h('th', [_h('button', {
    staticClass: "calendar__nav calendar__nav--prev",
    attrs: {
      "type": "button"
    },
    on: {
      "click": prevMonth
    }
  }, [_m(0)])]), " ", _h('th', {
    staticClass: "calendar__month",
    attrs: {
      "colspan": "5"
    }
  }, ["\n\t\t\t\t" + _s(month) + " " + _s(year) + "\n\t\t\t"]), " ", _h('th', [_h('button', {
    staticClass: "calendar__nav calendar__nav--next",
    attrs: {
      "type": "button"
    },
    on: {
      "click": nextMonth
    }
  }, [_m(1)])])]), " ", _h('tr', [_l((weekdaysMin), function(weekdayMin) {
    return _h('th', {
      staticClass: "calendar__weekday"
    }, ["\n\t\t\t\t" + _s(weekdayMin) + "\n\t\t\t"])
  })])]), " ", _h('tbody', [_l((weeks), function(week) {
    return _h('tr', [_l((week.days), function(day) {
      return _h('td', {
        class: day.classes()
      }, [_h('input', {
        attrs: {
          "type": "checkbox",
          "id": day.id,
          "data-date": day.dataDate,
          "data-up": day.dataUp,
          "data-right": day.dataRight,
          "data-down": day.dataDown,
          "data-left": day.dataLeft
        },
        domProps: {
          "checked": day.isChecked()
        },
        on: {
          "change": toggleDay,
          "keydown": [function($event) {
            if ($event.keyCode !== 38) return;
            goUp($event)
          }, function($event) {
            if ($event.keyCode !== 39) return;
            goRight($event)
          }, function($event) {
            if ($event.keyCode !== 40) return;
            goDown($event)
          }, function($event) {
            if ($event.keyCode !== 37) return;
            goLeft($event)
          }]
        }
      }), " ", _h('label', {
        attrs: {
          "for": day.id
        }
      }, [_h('span', [_s(day.label) + " " + _s(day.weekDayNumber)])])])
    })])
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('span', ["➞"])
}},function (){with(this) {
  return _h('span', ["➞"])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57533d1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 116
// module chunks = 2